import PropTypes from 'prop-types';

export const TabsItem = ({name, id, active, handleChangeTab}) => {
   
    const styleClass = active ? "active" : " ";

    const validateActiveTab = (e) =>{
        handleChangeTab(id);
        const listItems = document.getElementsByClassName("nav-item tab");
    
        for(let i = 0; i < listItems.length ; i++){
            listItems[i].classList.remove("active");
        }
        const item = document.getElementById(`${id}Item`);
        item.classList.add("active");
    }
    
    return (
        <li key={id} id={`${id}Item`} className={`ms-1 nav-item tab ${styleClass}`} role="presentation">
            <button className={`nav-link tabChange ${styleClass}`} id={id} data-id={id} data-bs-toggle="pill" type="button" 
            role="tab" aria-selected="true" onClick={validateActiveTab}>
                <span className="" data-localize="true">{name}</span>
            </button>
        </li>
    );

};

TabsItem.propTypes = {
    name: PropTypes.string,
    active: PropTypes.bool,
    id: PropTypes.string.isRequired
};